import { BLACK } from '@assets/styled/color.style';
import styled from '@emotion/styled';

export interface CommonTextProps {
  color?: string
}
export const CommonText = styled.div<CommonTextProps>`
  color: ${({ color = BLACK }) => color};
`;
